export const BASE_URL = process.env.REACT_APP_API_URL || "https://petroleum.norissolutions.in/PhpApi/Api/";
const PRODUCTION_DOMAIN = window.location.origin + "/";


const parseResponse = async (response) => {
  const text = (await response.text()).trim();
  try {
    const braceStart = text.indexOf('{');
    const bracketStart = text.indexOf('[');

    let jsonStart = -1;
    if (braceStart !== -1 && bracketStart !== -1) {
      jsonStart = Math.min(braceStart, bracketStart);
    } else if (braceStart !== -1) {
      jsonStart = braceStart;
    } else if (bracketStart !== -1) {
      jsonStart = bracketStart;
    }

    if (jsonStart === -1) throw new Error(`No JSON found in response: ${text.substring(0, 500)}...`);
    const jsonStr = text.substring(jsonStart);
    return JSON.parse(jsonStr);
  } catch (e) {
    console.error("Failed to parse JSON response:", text);
    throw new Error(`Invalid JSON response: ${text.substring(0, 500)}...`);
  }
};


export const api = {
  get: async (endpoint) => {
    try {
      const response = await fetch(`${BASE_URL}${endpoint}`);
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return await parseResponse(response);
    } catch (error) {
      console.error(`API Get Error (${endpoint}):`, error);
      throw error;
    }
  },

  post: async (endpoint, data) => {
    try {
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        formData.append(key, data[key]);
      });

      const response = await fetch(`${BASE_URL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${sessionStorage.getItem('token')}`
        },
        body: formData
      });
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}, body: ${errorText.substring(0, 1000)}`);
      }
      return await parseResponse(response);
    } catch (error) {
      console.error(`API Post Error (${endpoint}):`, error);
      throw error;
    }
  },

  postJSON: async (endpoint, data) => {
    try {
      const response = await fetch(`${BASE_URL}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${sessionStorage.getItem('token')}`
        },
        body: JSON.stringify(data)
      });
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! status: ${response.status}, body: ${errorText.substring(0, 1000)}`);
      }
      return await parseResponse(response);
    } catch (error) {
      console.error(`API PostJSON Error (${endpoint}):`, error);
      throw error;
    }
  },

  delete: async (endpoint) => {
    try {
      const response = await fetch(`${BASE_URL}${endpoint}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${sessionStorage.getItem('token')}`
        }
      });
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
      return await parseResponse(response);
    } catch (error) {
      console.error(`API Delete Error (${endpoint}):`, error);
      throw error;
    }
  }
};

export const fetchSales = (filters) => api.postJSON('Pages/SalesData.php', filters);
export const fetchCustomers = (companyId) => api.post('Pages/CustomerView.php', { Companyid: companyId });
export const fetchProducts = (companyId) => api.post('Pages/ProductView.php', { Companyid: companyId });
export const saveSale = (data) => api.postJSON('Pages/Sales.php', data);
export const saveCustomer = (data) => api.postJSON('Pages/CustomerReg.php', data);
export const deleteCustomer = (id) => api.delete(`Pages/CustomerReg.php?IDS=${id}`);
export const saveReceipt = (data) => api.post('Pages/ReceiptData.php', data);
export const fetchReceipts = (filters) => api.post('Pages/Receipts.php', filters);
export const deleteReceipt = (id) => api.delete(`Pages/ReceiptData.php?IDS=${id}`);
export const savePurchase = (data) => api.post('Pages/PurchaseData.php', data);
export const fetchPurchases = (filters) => api.post('Pages/Purchases.php', filters);
export const savePayment = (data) => api.post('Pages/PaymentsData.php', data);
export const fetchPayments = (filters) => api.post('Pages/Payments.php', filters);
export const deletePurchase = (id) => api.delete(`Pages/PurchaseData.php?IDS=${id}`);
export const deletePayment = (id) => api.delete(`Pages/PaymentsData.php?IDS=${id}`);
export const savePumpReading = (data) => api.post('Pages/PumpReading.php', data);
export const fetchPumpReadings = (data) => api.post('Pages/PumpReadingView.php', data);export const fetchPumps = (companyId) => api.post('Pages/PumpView.php', { Companyid: companyId });
export const fetchTanks = (companyId) => api.post('Pages/TankView.php', { Companyid: companyId });
export const fetchTankReadings = (data) => api.post('Pages/TankReadingView.php', data);export const saveTankReading = (data) => api.post('Pages/TankReading.php', data);
export const savePump = (data) => api.postJSON('Pages/PumpReg.php', data);
export const saveNozzle = (data) => api.postJSON('Pages/NozzleReg.php', data);
export const saveNozzleReading = (data) => api.postJSON('Pages/NozzleReading.php', data);
export const fetchNozzleReadings = (companyId) => api.post('Pages/NozzleReadingView.php', { Companyid: companyId });
export const saveDipReading = (data) => api.post('Pages/DipReading.php', data);
export const fetchDipReadings = (companyId) => api.post('Pages/DipReadingView.php', { Companyid: companyId });
export const fetchNozzles = (companyId) => api.post('Pages/NozzleView.php', { Companyid: companyId });
export const deleteSale = (id) => api.delete(`Pages/Sales.php?sale_id=${id}`);
export const deleteTankReading = (id) => api.delete(`Pages/TankReading.php?IDS=${id}`);
export const deletePumpReading = (id) => api.delete(`Pages/PumpReading.php?IDS=${id}`);
export const deleteNozzleReading = (id) => api.delete(`Pages/NozzleReading.php?IDS=${id}`);
export const deleteDipReading = (id) => api.delete(`Pages/DipReading.php?IDS=${id}`);
export const deleteTank = (id) => api.delete(`Pages/TankReg.php?IDS=${id}`);
export const deletePump = (id) => api.delete(`Pages/PumpReg.php?IDS=${id}`);
export const deleteNozzle = (id) => api.delete(`Pages/NozzleReg.php?IDS=${id}`);
export const fetchItemLoss = (companyId) => api.post('Pages/ItemLossView.php', { Companyid: companyId });
export const saveItemLoss = (data) => api.postJSON('Pages/ItemLoss.php', data);
export const deleteItemLoss = (id) => api.delete(`Pages/ItemLoss.php?IDS=${id}`);
export const fetchDashboardStats = (companyId) => api.post('Pages/DashBoard.php', { Companyid: companyId });
export const fetchDashboardPSStats = (companyId) => api.post('Pages/DashBoard_PS.php', { Companyid: companyId });
export const fetchDashboardMaterialStats = (companyId) => api.post('Pages/DashBoard_Material.php', { Companyid: companyId });
export const fetchSaleReturns = (filters) => api.post('Pages/SaleReturnView.php', filters);
export const saveSaleReturn = (data) => api.postJSON('Pages/SaleReturn.php', data);
export const deleteSaleReturn = (id) => api.delete(`Pages/SaleReturn.php?IDS=${id}`);
export const fetchPurchaseReturns = (filters) => api.post('Pages/PurchaseReturnView.php', filters);
export const savePurchaseReturn = (data) => api.postJSON('Pages/PurchaseReturn.php', data);
export const deletePurchaseReturn = (id) => api.delete(`Pages/PurchaseReturn.php?IDS=${id}`);
export const registerCompany = (data) => api.postJSON('Pages/CompanyReg.php', data);
export const forgotPassword = (data) => api.postJSON('Pages/ForgetPassword.php', data);
export const updatePassword = (data) => api.postJSON('Pages/PasswordUpdated.php', data);
export const finalizeRegistrationPassword = (data) => api.postJSON('Pages/PasswordUpdated1.php', data);

const getCleanVerificationLink = (email, companyId) => {
  return `${PRODUCTION_DOMAIN}emailverification.html?email=${email}&Companyid=${companyId}`;
};

export const sendVerificationEmail = (email, name, companyId = '1') => {
  const link = getCleanVerificationLink(email, companyId);
  const mailApiBase = process.env.REACT_APP_MAIL_API_BASE || "https://norissolutions.in/SendMail/";
  return fetch(`${mailApiBase}VerifyEmail.php?SenderEmail=${encodeURIComponent(email)}&SenderName=${encodeURIComponent(name)}&Link=${encodeURIComponent(link)}&CompanyID=${companyId}`)
    .then(res => res.json())
    .catch(err => {
      if (err.message === 'Failed to fetch') {
        return { success: true, status: 'probable_success', message: 'Email sent (CORS response blocked)' };
      }
      throw err;
    });
};

export const sendCompanyRegEmail = (email, name, companyId = '1') => {
  const link = getCleanVerificationLink(email, companyId);
  const mailApiBase = process.env.REACT_APP_MAIL_API_BASE || "https://norissolutions.in/SendMail/";
  return fetch(`${mailApiBase}PVerifyEmail.php?SenderEmail=${encodeURIComponent(email)}&SenderName=${encodeURIComponent(name)}&Link=${encodeURIComponent(link)}&CompanyID=${companyId}`)
    .then(res => res.json())
    .catch(err => {
      if (err.message === 'Failed to fetch') {
        return { success: true, status: 'probable_success', message: 'Email sent (CORS response blocked)' };
      }
      throw err;
    });
};

export const verifyEmailOTP = (email, name, otp, companyId = '1') => {
  const mailApiBase = process.env.REACT_APP_MAIL_API_BASE || "https://norissolutions.in/SendMail/";
  return fetch(`${mailApiBase}VerifyEmailOTP.php?SenderEmail=${encodeURIComponent(email)}&SenderName=${encodeURIComponent(name)}&OTP=${encodeURIComponent(otp)}&CompanyID=${companyId}`)
    .then(res => res.json())
    .catch(err => {
      if (err.message === 'Failed to fetch') {
        throw new Error('Verification service unreachable due to CORS. Please contact support or try from production domain.');
      }
      throw err;
    });
};
